export const ENCODER_CONTEXT = "encoder";
//# sourceMappingURL=encoder.js.map